export function userData() {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
        return user;
    } else {
        return {};
    }
}

export function userRoles() {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
        return user.user.roles;
    } else {
        return {};
    }
}

export const ADMINISTRATOR_ROLE_ID = 1;

export function isAdministrator() {
    let user = JSON.parse(localStorage.getItem('user'));
    const roles = (user && user.user && Array.isArray(user.user.roles)) ? user.user.roles : [];
    return roles.some((role) => parseInt(role.id, 10) === ADMINISTRATOR_ROLE_ID);
}
export function userRoleSlugs() {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
        return user.user.role_slug;
    } else {
        return {};
    }
}
export function userIsAuthor(author_id) {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user.user_id === author_id) {
        return true;
    } else {
        return false;
    }
}

export function hasPermission() {
    return userRoleSlugs();
}